import { Box, Grid } from '@mui/material'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useLoggedInUser } from '../../../../../app/hooks/useLoggedInUser'
import {
  useGetAllHsHeadingsQuery,
  useGetAllSubHsHeadingsQuery,
} from '../../../../../app/redux-fetch/apiProducts'
import DefaultSpacingGrid from '../../../../../components/Containers/DefaultSpacingGrid'
import FormSelect from '../../../../../components/Forms/FormSelect'
import InfoDisplayItem from '../../../../../components/Typographies/InfoDisplayItem'
import { IHsHeading, IHsSubheading } from '../../../../Products/types'
import { useOrderFormContext } from '../../../context/OrderFormContext'

interface HSCodesTabProps {
  prefix?: string
  disabled?: boolean
}

const HSCodesTab: React.FC<HSCodesTabProps> = ({ prefix = '', disabled = false }) => {
  const { watch, setValue } = useFormContext()
  const { tenantId } = useLoggedInUser()
  const { variant } = useOrderFormContext()

  const {
    data: hsHeadingItems = [] as IHsHeading[],
    isLoading: hsHeadingsLoading,
    isFetching: hsHeadingsFetching,
  } = useGetAllHsHeadingsQuery({ tenantId })
  const {
    data: hsSubheadingItems = [] as IHsSubheading[],
    isLoading: hsSubheadingsLoading,
    isFetching: hsSubheadingsFetching,
  } = useGetAllSubHsHeadingsQuery({ tenantId })

  const convertHsHeadingToLabelWithDescription= (
    items: Array<{ id?: undefined | number; headingCode: string; description: string }>
  ) => {
    return items.map((item) => ({
      label: `${item.headingCode} - ${item.description}`,
      value: item.id ?? 0,
    }))
  }

  const convertHssubHeadingToLabelWithDescription = (
    items: Array<{ id?: undefined | number; subheadingCode: string; description: string }>
  ) => {
    return items.map((item) => ({
      label: `${item.subheadingCode}${item.description}`,
      value: item.id ?? 0,
    }))
  }

  const hsHeadingOptions = convertHsHeadingToLabelWithDescription(hsHeadingItems)
  const selectedHsHeading = watch(`${prefix}.hsHeadingId`)

  const filteredHsSubheadings = selectedHsHeading
    ? hsSubheadingItems.filter((item) => item.hsHeadingId === selectedHsHeading)
    : []

  const hsSubheadingOptions = convertHssubHeadingToLabelWithDescription(filteredHsSubheadings)

  if (variant === 'summary') {
    return (
      <Box sx={{ padding: '22px 16px 0 16px' }}>
        <DefaultSpacingGrid container>
          <Grid item xs={12} md={12}>
            <InfoDisplayItem
              label={'HS Code Heading'}
              value={
                hsHeadingOptions.find((opt) => opt.value === watch(`${prefix}.hsHeadingId`))
                  ?.label || 'N/A'
              }
              isSmallScreen={false}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <InfoDisplayItem
              label={'HS Code Subheading'}
              value={
                hsSubheadingOptions.find((opt) => opt.value === watch(`${prefix}.hsSubheadingId`))
                  ?.label || 'N/A'
              }
              isSmallScreen={false}
            />
          </Grid>
        </DefaultSpacingGrid>
      </Box>
    )
  }

  return (
    <Box sx={{ padding: '22px 16px 0 16px' }}>
      <DefaultSpacingGrid container sx={{ mt: '-16px' }}>
        <Grid item xs={12} md={5}>
          <FormSelect
            name={`${prefix}.hsHeadingId`}
            label='HS Code Heading'
            options={hsHeadingOptions}
            required={!disabled}
            fullWidth
            disabled={disabled}
            loading={hsHeadingsFetching}
            onChange={(e) => {
              setValue(`${prefix}.hsSubheadingId`, null)
            }}
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <FormSelect
            name={`${prefix}.hsSubheadingId`}
            label='HS Code Subheading'
            options={hsSubheadingOptions}
            required={!disabled}
            fullWidth
            disabled={disabled}
            loading={hsSubheadingsFetching}
          />
        </Grid>
      </DefaultSpacingGrid>
    </Box>
  )
}

export default HSCodesTab
